export default (function (siteVars) { return ({
    colors: {
        primary: siteVars.brand06,
    },
    textColor: siteVars.gray02,
}); });
